import { FC } from 'react'
import { Config } from '../const'
import { getDay } from '../state/filter/filterSlice'
import { useAppSelector } from '../state/hooks'
import { isLoading } from '../state/timetable/timetableSlice'
import { getEntriesForArtists, getEntriesForHours } from './selectors'
import TimetableList, { ListType } from './TimetableList'

type Props = {
  type?: ListType
}

export const TimetableListContainer: FC<Props> = ({ type }) => {
  const isFavoritesList = type === 'favorites'

  const orderBy = Config.REACT_APP_SHOW_ARTISTS ? 'name' : 'time'

  const entriesByName = useAppSelector((state) =>
    getEntriesForArtists(state, isFavoritesList),
  )
  const entriesByHours = useAppSelector((state) =>
    getEntriesForHours(state, isFavoritesList),
  )

  const entries =
    orderBy === 'name'
      ? // @ts-ignore
        entriesByName
      : // @ts-ignore
        entriesByHours

  const loading = useAppSelector(isLoading)
  const day = useAppSelector(getDay)

  return (
    <TimetableList
      day={day}
      entries={entries}
      isLoading={loading}
      orderBy={orderBy}
      type={type}
    />
  )
}
